import { __assign, __read } from "tslib";
import { useState, useEffect, useRef } from 'react';
import { drag } from 'd3-drag';
import { zoom } from 'd3-zoom';
import { select, mouse, event } from 'd3-selection';
import { calculateEulerAngles } from '@keen.io/charts-utils';
export var useZoom = function (element, setProjectionState, initialScale) {
    var frameRequest = useRef(null);
    var _a = __read(useState(null), 2), zoomDirection = _a[0], setZoomDirection = _a[1];
    useEffect(function () {
        var handlers = zoom()
            .scaleExtent([1, 8])
            .on('zoom', function () {
            var _a;
            var zoom = event.transform;
            if ((_a = event.sourceEvent) === null || _a === void 0 ? void 0 : _a.wheelDelta) {
                var zoomDirection_1 = event.sourceEvent.wheelDelta > 0 ? 'zoom-in' : 'zoom-out';
                setZoomDirection(zoomDirection_1);
            }
            if (frameRequest.current)
                cancelAnimationFrame(frameRequest.current);
            frameRequest.current = requestAnimationFrame(function () {
                setProjectionState(function (state) { return (__assign(__assign({}, state), { scale: initialScale * zoom.k })); });
            });
        })
            .on('end', function () {
            setZoomDirection(null);
        });
        select(element.current).call(handlers);
        return function () {
            if (handlers)
                handlers.on('zoom', null);
        };
    }, [element.current]);
    return {
        zoomDirection: zoomDirection,
    };
};
export var useDragHandlers = function (element, projection, setProjectionState, dragBehaviour) {
    if (dragBehaviour === void 0) { dragBehaviour = 'rotate'; }
    var _a = __read(useState(null), 2), dragged = _a[0], setDragged = _a[1];
    var dragStartPosition = useRef(null);
    var frameRequest = useRef(null);
    useEffect(function () {
        var handlers = drag()
            .on('start', function () {
            dragStartPosition.current = projection.invert(mouse(element.current));
            setDragged(true);
        })
            .on('end', function () { return setDragged(false); })
            .on('drag', function () {
            if (dragBehaviour === 'translate') {
                var dx_1 = event.dx, dy_1 = event.dy;
                if (frameRequest.current) {
                    cancelAnimationFrame(frameRequest.current);
                }
                frameRequest.current = requestAnimationFrame(function () {
                    setProjectionState(function (state) { return (__assign(__assign({}, state), { translation: [
                            state.translation[0] + dx_1,
                            state.translation[1] + dy_1,
                        ] })); });
                });
            }
            if (dragBehaviour === 'rotate') {
                var dragCurrentPosition = projection.invert(mouse(element.current));
                var eulerAngles_1 = calculateEulerAngles(dragStartPosition.current, dragCurrentPosition, projection.rotate());
                if (eulerAngles_1) {
                    if (frameRequest.current)
                        cancelAnimationFrame(frameRequest.current);
                    frameRequest.current = requestAnimationFrame(function () {
                        setProjectionState(function (state) { return (__assign(__assign({}, state), { rotation: eulerAngles_1 })); });
                    });
                }
            }
        });
        select(element.current).call(handlers);
        return function () {
            var detachElement = select(element.current);
            if (detachElement)
                detachElement.on('mousedown.drag', null);
        };
    }, [element.current]);
    return {
        dragged: dragged,
    };
};
